import React from 'react'
import PropTypes from 'prop-types'

/**
 * One row's icon + label (+ optional badge), identical markup whether the rail
 * is collapsed or expanded — only style values change (gap, label-slot width,
 * label opacity). Nothing here is ever conditionally mounted/unmounted or
 * re-wrapped, which is what made the icon visibly jump/move on every toggle.
 *
 * Lives in its own module (rather than in MainNav.js) because MainNavModalItem.jsx
 * needs it too, and MainNav.js already imports MainNavModalItem — putting it there
 * would make the two files circular.
 */
export function NavRowContent({ item, t, sidebarExpanded, badgeText }) {
  const badgeStyle = {
    position: 'relative',
    top: '-8px',
    left: '-12px',
    flexShrink: 0,
  }
  
  return (
    <div className={`main-nav__link__content ${item.flexAlignClass || 'align-items-center'}`}>
      <span style={{ ...item.style }} title={t(`Menu.${item.key}`)}>
        {item.icon}
      </span>

      <span
        className={`main-nav__link__label-slot ${sidebarExpanded ? 'main-nav__link__label-slot--expanded' : ''}`}
      >
        <h5 className="main-nav__link__text" style={{ opacity: sidebarExpanded ? 1 : 0 }}>
          {t(`Menu.${item.key}`)}
        </h5>
      </span>

      {badgeText != null && (
        <span className='app-badge__text app-badge__text--inline'
        style={{ ...(!sidebarExpanded ? badgeStyle : {}) }}
        >
          {badgeText}
        </span>
      )}
    </div>
  )
}

NavRowContent.propTypes = {
  item: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  sidebarExpanded: PropTypes.bool.isRequired,
  badgeText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
